import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';

@Component({
	selector: 'app-site-advert-details-modal',
	templateUrl: './site-advert-details-modal.component.html',
	styleUrls: ['./site-advert-details-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SiteAdvertDetailsModalComponent {
	@Input() title: string;

	@Input() content: string;

	public modalId = 'site-advert-details-modal';

	constructor(
		private ms: ModalService,
	) { }

	cancel() {
		this.ms.close(this.modalId);
	}
}
